module.exports = __webpack_public_path__ + "img/expand.bcc0808e.png";